const messages = {
  'pt-BR': {
    subtitle: 'Gestão de Atendimentos',
    nav: {
      dashboard:      'Dashboard',
      appointments:   'Agendamentos',
      establishments: 'Estabelecimentos',
      professionals:  'Profissionais',
      services:       'Serviços',
      clients:        'Pessoas',
      financial:      'Financeiro',
      sales:          'Produtos',
      packages:       'Pacotes',
      relationship:   'Relacionamento',
      myCommissions:  'Comissões',
      mySales:        'Minhas vendas',
      myServices:     'Meus serviços',
      help:           'Ajuda',
      users:          'Usuários',
      platformDashboard: 'Dashboard',
      platformMap:       'Mapa de clientes',
      people:            'Pessoas',
      billingGroup:      'Planos e Assinaturas',
      platformFinancial: 'Financeiro',
      settings:          'Configurações',
      legal:             'Legal',
      requests:          'Solicitações',
      versioning:        'Versionamento',
      blog:              'Blog',
    },
    roles: {
      ADMIN:          'Administrador',
      RECEPTIONIST:   'Recepcionista',
      PROFESSIONAL:   'Profissional',
      CLIENT:         'Cliente',
      PLATFORM_OWNER: 'Dono da Plataforma',
    },
    actions: {
      logout:    'Sair da conta',
      darkMode:  'Modo escuro',
      lightMode: 'Modo claro',
      language:  'Idioma',
      save:      'Salvar',
      cancel:    'Cancelar',
      delete:    'Excluir',
      create:    'Criar',
      edit:      'Editar',
    },
    status: {
      SCHEDULED:   'Agendado',
      CONFIRMED:   'Confirmado',
      IN_PROGRESS: 'Em andamento',
      COMPLETED:   'Concluído',
      CANCELLED:   'Cancelado',
      CANCELLED_LATE: 'Cancelado (tardio)',
      NO_SHOW:     'Não compareceu',
    },
  },

  'pt-PT': {
    subtitle: 'Gestão de Marcações',
    nav: {
      dashboard:      'Dashboard',
      appointments:   'Marcações',
      establishments: 'Estabelecimentos',
      professionals:  'Profissionais',
      services:       'Serviços',
      clients:        'Pessoas',
      financial:      'Financeiro',
      sales:          'Produtos',
      packages:       'Pacotes',
      relationship:   'Relacionamento',
      myCommissions:  'Comissões',
      mySales:        'Minhas vendas',
      myServices:     'Meus serviços',
      help:           'Ajuda',
      users:          'Utilizadores',
      platformDashboard: 'Dashboard',
      platformMap:       'Mapa de clientes',
      people:            'Pessoas',
      billingGroup:      'Planos e Assinaturas',
      platformFinancial: 'Financeiro',
      settings:          'Configurações',
      legal:             'Legal',
      requests:          'Solicitações',
      versioning:        'Versionamento',
      blog:              'Blog',
    },
    roles: {
      ADMIN:          'Administrador',
      RECEPTIONIST:   'Rececionista',
      PROFESSIONAL:   'Profissional',
      CLIENT:         'Cliente',
      PLATFORM_OWNER: 'Dono da Plataforma',
    },
    actions: {
      logout:    'Terminar sessão',
      darkMode:  'Modo escuro',
      lightMode: 'Modo claro',
      language:  'Idioma',
      save:      'Guardar',
      cancel:    'Cancelar',
      delete:    'Eliminar',
      create:    'Criar',
      edit:      'Editar',
    },
    status: {
      SCHEDULED:   'Marcado',
      CONFIRMED:   'Confirmado',
      IN_PROGRESS: 'Em atendimento',
      COMPLETED:   'Concluído',
      CANCELLED:   'Cancelado',
      CANCELLED_LATE: 'Cancelado (tardio)',
      NO_SHOW:     'Não compareceu',
    },
  },
}

export function getMessages(locale) {
  return messages[locale] || messages['pt-BR']
}

export default messages
